import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import NavLink from 'react-bootstrap/NavLink';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Loader from 'react-loader';
import { fetchCareMessages, activeChat, patientChatSearch, resetChatWindow } from './actions';
import S3Image from '../helpers/S3Image';
import { getKeyName } from '../helpers/getKeyName';
import ProviderConversations from './ProviderConversations';

class ChatSidebar extends Component {
  state = {
    activeTab: 'Patient',
  };

  // componentWillReceiveProps(nextProps, nextContext) {
  //   if (
  //     this.props.activeSidebarPatientId !== nextProps.activeSidebarPatientId &&
  //     nextProps.activeSidebarPatientId
  //   ) {
  //     this.setState({ activeSidebarPatientId: nextProps.activeSidebarPatientId });
  //   }
  // }

  // componentDidUpdate(prevProps, prevState, prevContext) {
  //   if (this.props.activeSidebarPatientId) {
  //     document.getElementById(this.state.activeSidebarPatientId).scrollIntoView();
  //   }
  // }

  // componentWillUnmount() {
  //   this.setState({ activeSidebarPatientId: null });
  // }

  handleNavigation = (activeTab) => {
    this.setState({ activeTab });
  };
  render() {
    return (
      <div>
        <Loader loaded={this.props.loaded} />
        <Nav className={'custom-nav-tabs chat'}>
          <Col lg={6} style={{ padding: 0 }}>
            <NavItem>
              <NavLink onClick={() => this.handleNavigation('Patient')} active={this.state.activeTab === 'Patient'} href="#" className={'text-center'}>
                Patient
              </NavLink>
            </NavItem>
          </Col>
          <Col lg={6} style={{ padding: 0 }}>
            <NavItem>
              <NavLink onClick={() => this.handleNavigation('Provider')} active={this.state.activeTab === 'Provider'} href="#" className={'text-center'}>
                Provider
              </NavLink>
            </NavItem>
          </Col>
        </Nav>
        {this.state.activeTab === 'Patient' ? (
          <span>
            <Row>
              <Col lg={12}>
                <FormGroup className={'chat-sb-input'}>
                  <FormControl type="search" name="text" id="exampleEmail" placeholder="Search Patients" onChange={(e) => this.props.patientChatSearch(e.target.value)} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <ul className="friend">
                {this.props.patientList
                  .filter((obj) => obj.patientDetails)
                  .map(({ patientDetails, id, lastMessage, patientId }) => (
                    <li
                      key={id}
                      className={'person'}
                      onClick={() => {
                        this.props.resetChatWindow();
                        this.props.fetchCareMessages(id);
                        this.props.activeChat(patientId, id, patientDetails);
                      }}
                      id={patientDetails.id}
                    >
                      <S3Image s3Key={patientDetails.imageUrl} className={'rounded-circle img-navbar img-cover'} style={{ width: 50, height: 50 }} />
                      <span className={'name'}>{getKeyName(patientDetails, ['firstName', 'lastName'])}</span>
                      {/*<Badge className={'unread'} color={'fff'}>*/}
                      {/**/}
                      {/*</Badge>*/}
                      <span className={'preview'} style={{ fontWeight: 500 }}>
                        {lastMessage.message}
                      </span>
                    </li>
                  ))}
              </ul>
            </Row>
          </span>
        ) : (
          <ProviderConversations />
        )}
      </div>
    );
  }
}

ChatSidebar.propTypes = {
  loaded: PropTypes.bool,
  fetchCareMessages: PropTypes.func,
  activeChat: PropTypes.func,
  patientChatSearch: PropTypes.func,
  resetChatWindow: PropTypes.func,
};
ChatSidebar.defaultProps = {};

function mapStateToProps({ chat }) {
  return {
    loaded: chat.loaded,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchCareMessages, activeChat, patientChatSearch, resetChatWindow }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatSidebar);
